import React, { useEffect, useRef, useState } from 'react'
import './styles.scss'
import { LeftPanel } from 'share/domain/chat'
import { useAppSelector } from 'hooks/store'

interface ProgressBarProps {
  leftPanels: LeftPanel[]
}

const ProgressBar: React.FC<ProgressBarProps> = ({ leftPanels = [] }) => {
  const leftPanelsRef = useRef<LeftPanel[]>(leftPanels)
  const [attorneyName, setAttorneyName] = useState<string>('')
  const attorneyNameFromStore = useAppSelector(
    (state) => state.activeCase.matter?.attorneyName || ''
  )

  const formatItemType = (type: string): string => {
    return type
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase())
      .trim()
  }

  useEffect(() => {
    setAttorneyName(attorneyNameFromStore)
  }, [attorneyNameFromStore])

  useEffect(() => {
    leftPanelsRef.current = leftPanels
  }, [leftPanels])

  return (
    <div className={`progress-bar-desktop`}>
      <div className='progress-bar-content'>
        <div className='progress-bar-title-container'>
          <p className='progress-bar-title'>Attorney Information</p>
          <p className='progress-bar-subtitle'>{attorneyName}</p>
          {/* <p className='progress-bar-subtitle'>(555) 555-5555</p> */}
        </div>
        <div className='progress-bar-divider' />
        <div className='progress-bar-panels'>
          {leftPanels.map((list, index) => (
            <React.Fragment key={index}>
              {list.items.map((item, itemIndex) => (
                <div key={itemIndex} className='progress-bar-list-item'>
                  {item.status === 'Ready' && (
                    <>
                      <span>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='24'
                          height='24'
                          viewBox='0 0 24 24'
                          fill='none'
                        >
                          <path
                            d='M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z'
                            fill='#16A550'
                          />
                        </svg>
                      </span>
                      <p>{formatItemType(item.type)}</p>
                    </>
                  )}
                  {(item.status === 'Pending' || item.status === 'Current') && (
                    <>
                      <span>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='20'
                          height='20'
                          viewBox='0 0 20 20'
                          fill='none'
                        >
                          <path
                            d='M10 18C7.87827 18 5.84344 17.1571 4.34315 15.6569C2.84285 14.1566 2 12.1217 2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2C12.1217 2 14.1566 2.84285 15.6569 4.34315C17.1571 5.84344 18 7.87827 18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18ZM10 0C8.68678 0 7.38642 0.258658 6.17317 0.761205C4.95991 1.26375 3.85752 2.00035 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0Z'
                            fill='#173237'
                          />
                        </svg>
                      </span>
                      <p>{formatItemType(item.type)}</p>
                    </>
                  )}
                </div>
              ))}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ProgressBar
